module.exports = __webpack_public_path__ + "img/logo-login.f613f757.png";